import React from "react";
import PropTypes from "prop-types";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Row,
  Table,
} from "reactstrap";

import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { goBack } from "connected-react-router";
import Can from "../../components/can";
import PinModal from "../../components/pin";
import { deleteDstRegion, fetchDstRegion } from "../../actions/dst-regions";
import { dstRegionsPath } from "../../routes";
import { MONTH_NAMES } from "../../constants/month-names";
import { WEEKDAY_NAMES } from "../../constants/weekday-names";
import { WEEKDAY_ORDINALS } from "../../constants/weekday-ordinal";

class DstRegion extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      submitted: false,
    };
    this.handleDelete = this.handleDelete.bind(this);
    this.requestDelete = this.requestDelete.bind(this);
    this.failedDelete = this.failedDelete.bind(this);
  }

  componentWillMount() {
    const { getDstRegion } = this.props;
    getDstRegion();
  }

  requestDelete(e) {
    e.preventDefault();
    this.setState({
      submitted: true,
    });
  }

  failedDelete() {
    this.setState({
      submitted: false,
    });
  }

  handleDelete() {
    const { deleteDstRegionAction, goToList } = this.props;
    deleteDstRegionAction().then(() => goToList());
  }

  render() {
    const { submitted } = this.state;
    const { dstRegion } = this.props;
    if (!dstRegion || Object.keys(dstRegion).length === 0) {
      return null;
    }
    return (
      <div className="animated fadeIn">
        {submitted && (
          <PinModal
            successSubmit={this.handleDelete}
            failedSubmit={this.failedDelete}
          />
        )}
        <Row>
          <Col lg={6}>
            <Card>
              <CardHeader>
                <strong>
                  {"DST Region ID: "}
                  {dstRegion.id}
                </strong>
                <div className="card-header-actions">
                  <Can I="update" a="DstRegion">
                    <Button
                      href={`/#/${dstRegionsPath}/${dstRegion.id}/edit`}
                      color="link"
                      className="card-header-action btn-setting"
                    >
                      <i className="icon-note" />
                    </Button>
                  </Can>
                  <Can I="delete" a="DstRegion">
                    <Button
                      color="link"
                      className="card-header-action btn-setting"
                      onClick={(e) => this.requestDelete(e)}
                    >
                      <i className="icon-trash" />
                    </Button>
                  </Can>
                </div>
              </CardHeader>
              <CardBody>
                <Table responsive striped hover>
                  <tbody>
                    <tr key="id">
                      <td>ID:</td>
                      <td>
                        <strong>{dstRegion.id}</strong>
                      </td>
                    </tr>
                    <tr key="display_name">
                      <td>Name:</td>
                      <td>
                        <strong>{dstRegion.display_name}</strong>
                      </td>
                    </tr>
                    <tr key="start.month">
                      <td>Start Month:</td>
                      <td>
                        <strong>{MONTH_NAMES[dstRegion.start.month]}</strong>
                      </td>
                    </tr>
                    <tr key="start.weekday">
                      <td>Start Weekday:</td>
                      <td>
                        <strong>
                          {WEEKDAY_NAMES[dstRegion.start.weekday]}
                        </strong>
                      </td>
                    </tr>
                    <tr key="start.weekday_ordinal">
                      <td>Start Weekday Ordinal:</td>
                      <td>
                        <strong>
                          {
                            WEEKDAY_ORDINALS.find(
                              (item) =>
                                item.value === dstRegion.start.weekday_ordinal,
                            ).description
                          }
                        </strong>
                      </td>
                    </tr>
                    <tr key="end.month">
                      <td>End Month:</td>
                      <td>
                        <strong>{MONTH_NAMES[dstRegion.end.month]}</strong>
                      </td>
                    </tr>
                    <tr key="end.weekday">
                      <td>End Weekday:</td>
                      <td>
                        <strong>{WEEKDAY_NAMES[dstRegion.end.weekday]}</strong>
                      </td>
                    </tr>
                    <tr key="end.weekday_ordinal">
                      <td>End Weekday Ordinal:</td>
                      <td>
                        <strong>{WEEKDAY_ORDINALS.find(
                          (item) =>
                            item.value === dstRegion.end.weekday_ordinal,
                        ).description}</strong>
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </CardBody>
              <CardFooter>
                <Button
                  href={`/#/${dstRegionsPath}/${dstRegion.id}/edit`}
                  color="secondary"
                  size="sm"
                >
                  Edit
                </Button>{" "}
                <Button
                  color="danger"
                  onClick={(e) => this.requestDelete(e)}
                  size="sm"
                >
                  Delete
                </Button>
              </CardFooter>
            </Card>
          </Col>
        </Row>
      </div>
    );
  }
}

DstRegion.propTypes = {
  deleteDstRegionAction: PropTypes.func.isRequired,
  getDstRegion: PropTypes.func.isRequired,
  goToList: PropTypes.func.isRequired,
  dstRegion: PropTypes.shape({}),
};

DstRegion.defaultProps = {
  dstRegion: {},
};

const mapStateToProps = ({ dstRegions }) => ({
  dstRegion: dstRegions.item,
});

const mapDispatchToProps = (dispatch, ownProps) =>
  bindActionCreators(
    {
      deleteDstRegionAction: () => deleteDstRegion(ownProps.match.params.id),
      getDstRegion: () => fetchDstRegion(ownProps.match.params.id),
      goToList: () => goBack(),
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(DstRegion);
